
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contactanos",
      function () {
        return require("private-next-pages/contactanos.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contactanos"])
      });
    }
  